import React from 'react'
import styled from 'styled-components'

import { media } from 'styles/media'

const Text = styled.p`
  margin-top: 40px;

  font-size: ${({ theme }) =>
    theme?.['-ds-font-size-md']?.['font-size']?.value};
  line-height: 1.3;
  font-weight: 400;

  ${media.md`
    margin-top: 60px;
    font-size: ${({ theme }) =>
      theme?.['-ds-font-size-lg']?.['font-size']?.value};
    line-height: 1.4;
  `}
`

const Outer = styled.div<{ backgroundColor?: string }>`
  padding: 16px;
  border-radius: 16px;

  text-align: left;

  color: ${({ theme }) => theme?.['-ds-neutral-700']?.value};
  ${({ backgroundColor }) =>
    backgroundColor &&
    `
    background-color: ${backgroundColor};
  `};

  flex-shrink: 0;
  flex-grow: 0;
  width: 236px;

  svg {
    width: 45px;
    height: 45px;
  }

  ${media.md`
    width: 300px;
    min-height: 273px;

    svg {
      width: 64px;
      height: 64px;
    }
  `}
`

type ValueCardProps = {
  icon: JSX.IntrinsicElements['svg'] | (() => JSX.IntrinsicElements['svg'])
  text: React.ReactNode
  backgroundColor?: string
}

const ValueCard = ({ icon, text, backgroundColor }: ValueCardProps) => {
  return (
    <Outer backgroundColor={backgroundColor}>
      {icon || <svg />}
      <Text>{text}</Text>
    </Outer>
  )
}

export default ValueCard
